var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "arrownavigation d-flex" }, [
    _vm.showBackButton === true
      ? _c(
          "div",
          {
            staticClass: "clickable mr-2",
            attrs: { role: "button" },
            on: {
              click: function ($event) {
                return _vm.changeSection(true)
              },
            },
          },
          [
            _c(
              "BaseIcon",
              { attrs: { width: "40", height: "40", flipH: "" } },
              [_c("ChevronCircle")],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.showForwardButton === true
      ? _c(
          "div",
          {
            staticClass: "clickable",
            attrs: { role: "button" },
            on: { click: _vm.changeSection },
          },
          [
            _c(
              "BaseIcon",
              { attrs: { width: "40", height: "40" } },
              [_c("ChevronCircle")],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }